import { useEffect, useState } from "react";
import useGetData from "hooks/api/useGetData";
import { PaymentMethodObject } from "types/api/api";
import { useAppContext } from "context/AppContext";

/**
 * Hook used to extract server data payment method based on payment method which user selected on the first screen
 */
const useGetSelectedPaymentMethodData = () => {
  const { data } = useGetData();
  const appReducerPayment = useAppContext();
  const [paymentMethodData, setPaymentMethodData] = useState<PaymentMethodObject | null>(null);

  useEffect(() => {
    if (data) {
      const paymentMethod = data?.paymentMethods?.find(
        (item) => item?.paymentProviderId === appReducerPayment?.paymentMethod
      );
      if (paymentMethod) {
        setPaymentMethodData(paymentMethod);
      }
    }
  }, [data, appReducerPayment?.paymentMethod]);

  return { data: paymentMethodData };
};

export default useGetSelectedPaymentMethodData;
